import dayjs from "dayjs";
import { useNavigate, useParams } from "react-router-dom";
import { CourseBadge } from "../../badge/courseBadge";


interface IProps {
    paidHistory: IPaidHistoryV3
    style?: React.CSSProperties
}

const PaidHistoryCard = ({ paidHistory, style }: IProps) => {
    const navigate = useNavigate();
    const { memberId } = useParams();
    return <div key={paidHistory.id} style={{ cursor: "pointer", ...style }} onClick={() => paidHistory.type === 'PROGRAM' ? navigate(`/my/paid-history/program/${memberId}/${paidHistory.id}`) : navigate(`/my/paid-history/${memberId}/${paidHistory.id}`)}>
        <div className="body/b1 secondary/s500">
            {dayjs(paidHistory.paymentDateTime).format('YYYY.MM.DD')}
        </div>
        <div className="sub-title/st3 secondary/s800" style={{ marginBlock: 8 }}>
            {paidHistory.title}
        </div>

        <div className="sub-title/st3 base/black" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <div>
                {paidHistory.isRefund && <div className="caption/c1 error/e600" style={{ padding: '4px 8px', borderRadius: 4, backgroundColor: '#FFEDED' }}>환불완료</div>}
            </div>
            {paidHistory.targetPrice ? paidHistory.targetPrice.toLocaleString() + " 원" : "0 원"}
        </div>
    </div>
}
export { PaidHistoryCard }